(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('BuscadorProyectos', BuscadorProyectos);

    BuscadorProyectos.$inject = ['$resource', 'DateUtils'];

    function BuscadorProyectos ($resource, DateUtils) {
        var resourceUrl =  '';

        return $resource(resourceUrl, {}, {
            'proyectosVigentes': { 
            	method: 'GET', 
            	url:'buscador-proyectos/proyectos/vigentes/:idCentroDocente,:idProgramaEducativo,:fechaFin',
            	isArray: true
           	},
            'programasEducativos': { 
            	method: 'GET',
            	url:'buscador-proyectos/programas-educativos',
            	isArray: true
           	},
            'programasEducativosByCentroDocente': { 
            	method: 'GET',
            	url:'buscador-proyectos/programas-educativos/:idCentroDocente',
            	isArray: true
           	},
            'centrosDocentes': { 
            	method: 'GET',
            	url:'buscador-proyectos/centros-docentes',
            	isArray: true
           	},
            'periodos': { 
            	method: 'GET',
            	url:'buscador-proyectos/periodos',
            	isArray: true
           	},
            'getSolicitud': {
                method: 'GET',
            	url:'buscador-proyectos/:id/solicitud',                
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.periodoInicial.iniPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniPeriodo);
                        data.periodoInicial.finPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.finPeriodo);
                        data.periodoInicial.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniConvocatoria);
                        data.periodoInicial.finConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.finConvocatoria);
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
        });
    }
})();
